<template>
  <div :class="['img-swipe', renderLimit && 'limit']" ref="swpWrapper">
    <div class="pswp" ref="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="pswp__bg"></div>
      <div class="pswp__scroll-wrap">
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
          <div class="pswp__top-bar">
            <div class="pswp__counter"></div>

            <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
            <!-- element will get class pswp__preloader--active when preloader is running -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>

          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
          </button>

          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
          </button>

          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import load from '@/utils/fangcloud-loader'
import ajax from '@/utils/ajax'
import PreviewCore from '@/utils/PreviewCore'
import {normalizeFile} from '@/utils/fileUtils'
import {GET_SIBLING} from '@/config/api'

const defaultItem = {
  w: 0,
  height: 0,
  html: `<div class="van-loading van-loading--circular van-loading" style="color: rgb(201, 201, 201);">
    <span class="van-loading__spinner van-loading__spinner--circular">
      <svg viewBox="25 25 50 50" class="van-loading__circular">
        <circle cx="50" cy="50" r="20" fill="none"></circle>
      </svg>
    </span>
  </div>`
}

// 初始化 photoswipe， 默认三个轮播元素，组件内维护计数器
// 给 photoswipe 手动加上了禁止左右滑动的api
export default {
  name: 'ImageSwipe',
  props: {
    item: Object,
    previewInfo: Object,
    renderLimit: Boolean,
    isFileSharing: Boolean,
    scenario: String
  },
  data () {
    return {
      initialIndex: 0,
      currentIndex: 0,
      staticUrl: process.env.ASSETS_URL ? process.env.ASSETS_URL : '/'
    }
  },
  watch: {
    currentIndex (val) {
      const idsLength = this.store.imgPreviewInfo.ids.length
      const lastId = this.store.imgPreviewInfo.ids[idsLength - 1]
      const lastItem = this.store.imgPreviewInfo.items[lastId]
      if (idsLength - val < 5 && !this.isFetchingSiblings && (!lastItem.hasOwnProperty('image_has_right_sibling') || lastItem.image_has_right_sibling)) {
        this.fetchSiblings(lastId)
      }
    }
  },
  mounted () {
    this.getSwipeItems()
  },
  beforeDestroy () {
    this.isDestroyed = true
    this.previewCore && this.previewCore.destroy()
  },
  methods: {
    getSwipeItems () {
      this.currentItemId = this.item.id
      const imgArr = this.store.imgPreviewInfo.ids.map((file_id, index) => {
        if (file_id === Number(this.previewInfo.file_id)) {
          this.initialIndex = this.currentIndex = index
          return {
            file_id,
            download_url: this.previewInfo.download_url,
            exif_rotation: this.previewInfo.exif_rotation
          }
        } else {
          return {
            file_id,
            isLoading: true
          }
        }
      })

      const promiseArr = []
      imgArr.forEach(item => {
        if (item.isLoading) {
          promiseArr.push(Promise.resolve(defaultItem))
        } else {
          promiseArr.push(this.setImageData(item))
        }
      })
      Promise.all(promiseArr).then(arr => {
        arr = arr.filter(item => item)
        if (!window.PhotoSwipe) {
          let self = this
          Promise.all([
            load.js(this.staticUrl + 'h5assets/photoswipe.min.js'),
            load.js(this.staticUrl + 'h5assets/photoswipe-ui-default.min.js')
          ]).then(_ => {
            self.initSwipe(arr)
          })
        } else {
          this.initSwipe(arr)
        }
      })
    },
    initSwipe (items) {
      const pswpElement = this.$refs.pswp
      const options = {
        index: this.initialIndex,
        loop: false,
        history: false,
        modal: false,
        maxSpreadZoom: 2,
        pinchToClose: false,
        closeOnVerticalDrag: false
      }

      if (this.gallery) {
        this.gallery.destroy()
      }
      this.gallery = window.gallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, items, options)
      this.gallery.init()

      this.gallery.listen('afterChange', () => {
        const index = this.currentIndex = this.gallery.getCurrentIndex()
        const file_id = this.store.imgPreviewInfo.ids[index]
        const fileItem = this.store.imgPreviewInfo.items[file_id]
        this.$emit('image-swipe', fileItem)
        const { src } = this.gallery.items[index]

        // TODO: 有可能文件上传了新版本 这边还在用老的链接
        if (!src) {
          this.previewCore = new PreviewCore({
            item: this.store.imgPreviewInfo.items[file_id],
            stateChangedCallback: (data) => {
              if (this.currentIndex === index && data.error) {
                this.$emit('state-change', data)
              }
              if (data.previewInfo) {
                this.setImageData(data.previewInfo).then(itemInfo => {
                  if (this.currentIndex !== index) {
                    return
                  }

                  this.gallery.items.splice(index, 1, itemInfo)
                  // sets a flag that slides should be updated
                  this.gallery.invalidateCurrItems()
                  // updates the content of slides
                  this.gallery.updateSize(true)
                })
              }
            },
            scenario: this.scenario
          })
          // 分享场景去除重复请求
          if (this.scenario !== 'share') {
            this.previewCore.start()
          }
        }
      })

      let that = this
      this.gallery.framework.bind(this.gallery.scrollWrap, 'pswpTap', function (e) {
        const index = that.currentIndex = that.gallery.getCurrentIndex()
        const file_id = that.store.imgPreviewInfo.ids[index]
        const fileItem = that.store.imgPreviewInfo.items[file_id]
        that.$emit('image-tap', fileItem)
      })
    },
    setImageData (item) {
      const {file_id, download_url, exif_rotation} = item
      return this.loadImage(download_url).then((imageData) => {
        if (this.isDestroyed) return Promise.reject(false)
        if (imageData) {
          let { url, width, height } = imageData
          let imgHeight = height
          let imgWidth = width
          const rotate = this.getInitDeg(exif_rotation)
          const changedWH = rotate % 90 === 1
          if (changedWH) { // 旋转了奇数个90度
            let temp = width
            width = height
            height = temp
          }

          const {offsetWidth, offsetHeight} = this.$refs.swpWrapper
          // add image margin
          if (offsetWidth < width || offsetHeight < (height + 20)) {
            imgHeight = Math.round(height / Math.max(width / offsetWidth, height / offsetHeight))
            imgWidth = width / height * imgHeight
            if (changedWH) {
              imgHeight = Math.round((width / height) * imgHeight)
              imgWidth = height / width * imgHeight
            }
          }

          return Promise.resolve({
            file_id,
            w: imgWidth,
            h: imgHeight,
            src: url
          })
        } else {
          return Promise.resolve({
            file_id,
            src: download_url,
            loadError: true
          })
        }
      })
    },
    loadImage (url) {
      const img = document.createElement('img')
      let promiseResolve
      const promise = new Promise((resolve) => { promiseResolve = resolve })
      img.setAttribute('style', 'display: none')
      img.onload = () => {
        img.setAttribute('style', 'display:block;position:absolute;left:-99999px;top:-99999px;')
        const { width, height } = img.getBoundingClientRect()
        promiseResolve({
          width,
          height,
          url
        })
        img.parentNode.removeChild(img)
      }

      img.onerror = () => {
        promiseResolve(false)
      }

      document.body.appendChild(img)
      img.src = url

      return promise
    },
    getInitDeg (exif_rotation) {
      if (exif_rotation > 1) {
        let rotate = 0
        switch (exif_rotation) {
          case 6:
            rotate += 90
            break
          case 8:
            rotate -= 90
            break
          case 3:
            rotate += 180
            break
        }
        return rotate
      }
    },
    fetchSiblings (file_id) {
      if (this.isFileSharing || this.$route.query.version) return
      let [sort_by, sort_direction] = this.store.sortInfo.split('_')
      sort_by = sort_by || undefined

      let url = GET_SIBLING
      if (this.scenario === 'share') {
        url += '?scenario=share'
      }

      ajax({
        url,
        data: {
          file_id,
          sort_by,
          sort_direction,
          extension_category: 'image',
          type: 'right',
          num: 5
        }
      }).then(res => {
        if (res && res.success && res.siblings) {
          res.siblings.forEach(item => {
            normalizeFile(item)
            if (this.store.imgPreviewInfo.ids.indexOf(item.id) === -1) {
              this.store.imgPreviewInfo.ids.push(item.id)
              this.gallery.items.push(Object.assign({}, defaultItem, {file_id: item.id}))
              this.store.imgPreviewInfo.items[item.id] = item
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="postcss">
.img-swipe {
  height: 100%;
  overflow: hidden;
  position: relative;

  & .van-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -15px;
    margin-top: -15px;
  }

  &.limit img {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
  }
}

/*! PhotoSwipe main CSS by Dmitry Semenov | photoswipe.com | MIT license */
/*
Styles for basic PhotoSwipe functionality (sliding area, open/close transitions)
*/
/* pswp = photoswipe */
.pswp {
  display: none;
  position: absolute !important;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  -ms-touch-action: none;
  touch-action: none;
  z-index: 1500;
  -webkit-text-size-adjust: 100%;
  /* create separate layer, to avoid paint on window.onscroll in webkit/blink */
  -webkit-backface-visibility: hidden;
  outline: none;
}
.pswp * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.pswp img {
  max-width: none;
}

/* style is added when JS option showHideOpacity is set to true */
.pswp--animate_opacity {
  /* 0.001, because opacity:0 doesn't trigger Paint action, which causes lag at start of transition */
  opacity: 0.001;
  will-change: opacity;
  /* for open/close transition */
  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
  transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
}

.pswp--open {
  display: block;
}

.pswp__ui {
  display: none;
}

.pswp--zoom-allowed .pswp__img {
  /* autoprefixer: off */
  cursor: -webkit-zoom-in;
  cursor: -moz-zoom-in;
  cursor: zoom-in;
}

.pswp--zoomed-in .pswp__img {
  /* autoprefixer: off */
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: grab;
}

.pswp--dragging .pswp__img {
  /* autoprefixer: off */
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: grabbing;
}

/*
Background is added as a separate element.
As animating opacity is much faster than animating rgba() background-color.
*/
.pswp__bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  will-change: opacity;
}

.pswp__scroll-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.pswp__container,
.pswp__zoom-wrap {
  -ms-touch-action: none;
  touch-action: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

/* Prevent selection and tap highlights */
.pswp__container,
.pswp__img {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

.pswp__zoom-wrap {
  position: absolute;
  width: 100%;
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  transform-origin: left top;
  /* for open/close transition */
  -webkit-transition: -webkit-transform 333ms cubic-bezier(0.4, 0, 0.22, 1);
  transition: transform 333ms cubic-bezier(0.4, 0, 0.22, 1);
}

.pswp__bg {
  will-change: opacity;
  /* for open/close transition */
  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
  transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
}

.pswp--animated-in .pswp__bg,
.pswp--animated-in .pswp__zoom-wrap {
  -webkit-transition: none;
  transition: none;
}

.pswp__container,
.pswp__zoom-wrap {
  -webkit-backface-visibility: hidden;
}

.pswp__item {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
}

.pswp__img {
  position: absolute;
  width: auto;
  height: auto;
  top: 0;
  left: 0;
}

/*
stretched thumbnail or div placeholder element (see below)
style is added to avoid flickering in webkit/blink when layers overlap
*/
.pswp__img--placeholder {
  -webkit-backface-visibility: hidden;
}

/*
div element that matches size of large image
large image loads on top of it
*/
.pswp__img--placeholder--blank {
  background: #222;
}

.pswp--ie .pswp__img {
  width: 100% !important;
  height: auto !important;
  left: 0;
  top: 0;
}

/*
Error message appears when image is not loaded
(JS option errorMsg controls markup)
*/
.pswp__error-msg {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100% !important;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  margin-top: -8px;
  color: #ccc;
}

.pswp__error-msg a {
  color: #ccc;
  text-decoration: underline;
}
</style>
